import React from 'react';
import { Route, Switch } from 'react-router-dom';

// Leave this commented out for now since we don't want the Feed to import these huge apps
// until we get them code split properly.

import LazyBrowsePageWithStore from './LazyBrowsePageWithStore';
import LazyFeedPageWithStore from './LazyFeedPageWithStore';
import LazySearchPageWithStore from './LazySearchPageWithStore';
import LazyCategoryBrowsePage from './LazyCategoryBrowsePage';

const SearchPageRoutes = (props) => (
    <Switch>
        <Route
            path={`${props.match.path}/events/`}
            render={(routerProps) => (
                <LazyBrowsePageWithStore {...props} {...routerProps} />
            )}
        />
        <Route
            path={`${props.match.path}/:query`}
            render={(routerProps) => {
                if (
                    routerProps.match.params.query === 'browse2020' &&
                    props.user.isStaff
                ) {
                    return (
                        <LazyCategoryBrowsePage {...props} {...routerProps} />
                    );
                }
                return <LazySearchPageWithStore {...props} {...routerProps} />;
            }}
        />
    </Switch>
);

export default function PageRoutes(props) {
    return (
        <Switch>
            {/* /esi_cache is the request path when Varnish renders the page */}
            <Route
                path="/esi_cache"
                exact={true}
                render={(routerProps) => (
                    <LazyFeedPageWithStore {...props} {...routerProps} />
                )}
            />
            <Route
                path="/"
                exact={true}
                render={(routerProps) => (
                    <LazyFeedPageWithStore {...props} {...routerProps} />
                )}
            />
            <Route
                path="/d/:locationSlug"
                render={(routerProps) => (
                    <SearchPageRoutes {...props} {...routerProps} />
                )}
            />
        </Switch>
    );
}
